import { Box, styled } from '@mui/material';

export const StyledContainerForHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const StyledContainer = styled(Box)(() => ({
  marginTop: '14px',
}));

export const StyledFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
